import { getBootstrapData } from "@swa-ui/bootstrap";
import { useDeviceInfo } from "@swa-ui/browser";

import { CARTRAWLER_ENVIRONMENT_PROD } from "../../defines";
import { generateCarTrawlerDeeplink } from "../../generateCarTrawlerDeeplink";
import { getCarTrawlerDeeplinkParamsFromSegments } from "../../getCarTrawlerDeeplinkParamsFromSegments";

/**
 * Hook that resolves the CarTrawler base URL and clientID from the current environment and
 * returns a bound deeplink generator.
 *
 * The environment is read from `useDeviceInfo()`; production selects `CARTRAWLER_SELECT_PROD`
 * from bootstrap `urls`, all other environments select `CARTRAWLER_SELECT_NON_PROD`. The
 * clientID is read from bootstrap `car-vendor-config`, which is configured per environment
 * at bootstrap time.
 *
 * @returns {{
 *   getCarDeeplink: (flightSegments: Array[]) => (String|null)
 * }}
 */
export const useCarDeeplink = () => {
  const { environment } = useDeviceInfo() || {};
  const { CARTRAWLER_SELECT_NON_PROD, CARTRAWLER_SELECT_PROD } = getBootstrapData("urls") || {};
  const { clientID } = getBootstrapData("car-vendor-config") || {};
  const baseUrl =
    environment === CARTRAWLER_ENVIRONMENT_PROD
      ? CARTRAWLER_SELECT_PROD
      : CARTRAWLER_SELECT_NON_PROD;

  const getCarDeeplink = (flightSegments) => {
    const params = getCarTrawlerDeeplinkParamsFromSegments(flightSegments);

    return params ? generateCarTrawlerDeeplink({ baseUrl, clientID, ...params }) : null;
  };

  return { getCarDeeplink };
};
